/**
 * Sector operations — Plant starters client service.
 * R39 J3.a (plan docs/plans/sector-operations.md §Part J, SO-D44, SO-P265, SO-P40, SO-P22).
 */

import { callable } from './callable'
import type {
  GetPlantStarterStatusInput,
  GetPlantStarterStatusResult,
} from '../types/ops'

export async function getPlantStarterStatus(
  input: GetPlantStarterStatusInput,
): Promise<GetPlantStarterStatusResult> {
  return callable<GetPlantStarterStatusInput, GetPlantStarterStatusResult>(
    'getPlantStarterStatus',
    input,
  )
}
